export default __webpack_public_path__ + "static/media/abld_inverted_reading.d8ee3dd98e57fad1ebf5afdeda1ae832.svg";